module.exports = __webpack_public_path__ + "fonts/InstagramSans-Medium.ec49c1ba.eot";